import { clearTbSiteOrgCache, clearSaasMembershipCache } from '../saas/lib/saasOrg';
import { invalidateCachedValuesByPrefix } from './supabaseSafeQuery';

const STORAGE_KEY = 'tb:app:build-version';

async function purgePwaCachesAndReload(): Promise<void> {
  try {
    if ('caches' in window) {
      const names = await caches.keys();
      await Promise.all(names.map((name) => caches.delete(name)));
    }
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }
  } catch {
    /* ignore */
  }
  window.location.reload();
}

/**
 * When index.html build-version changes, purge stale client caches and reload once.
 * Critical for installed PWAs that keep old JS bundles until a hard refresh.
 */
export function syncAppBuildVersion(): boolean {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;

  const version = document.querySelector('meta[name="build-version"]')?.getAttribute('content')?.trim() || '';
  if (!version) return false;

  const previous = localStorage.getItem(STORAGE_KEY);
  if (previous === version) return false;

  localStorage.setItem(STORAGE_KEY, version);

  try {
    invalidateCachedValuesByPrefix('profile:');
    clearTbSiteOrgCache();
    clearSaasMembershipCache();
  } catch {
    /* ignore */
  }

  if (previous) {
    void purgePwaCachesAndReload();
    return true;
  }

  return false;
}
